import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

import { ColouredCard } from 'inside-out/components/shared/cards/colouredCard';
import { contentSection } from 'inside-out/global-styles';

import { descriptionToHex } from 'inside-out/managers/colourManager';

import {
	wrapperStyle,
	innerWrapperStyle,
	titleStyle,
	textStyle,
	cardsSectionStyle,
} from 'inside-out/page-styles/get-involved/detail';

import { detailSideBarLayout } from 'inside-out/global-styles';

export default class MakeADonationPage extends React.PureComponent {
	static propTypes = {
		data: PropTypes.shape({
			page: PropTypes.shape({
				edges: PropTypes.arrayOf(
					PropTypes.shape({
						node: PropTypes.shape({
							heading: PropTypes.string.isRequired,
							body: PropTypes.string.isRequired,
							tiles: PropTypes.arrayOf(
								PropTypes.shape({
									heading: PropTypes.string,
									body: PropTypes.string,
									link_destination: PropTypes.string,
									colour: PropTypes.string,
								})
							),
						}).isRequired,
					})
				).isRequired,
			}).isRequired,
		}).isRequired,
	};

	render() {
		const pageSettings = this.props.data.page.edges[0].node;

		return (
			<React.Fragment>
				<Helmet title={pageSettings.heading}>
          <meta property="og:type" content="website"/>
          <meta property="og:title" content={pageSettings.heading}/>
          <meta name="description" content="Donate now to help people living with, or affected by an eating disorder today."/>
          <meta property="og:description" content="Donate now to help people living with, or affected by an eating disorder today."/>
        </Helmet>
				<section className={wrapperStyle}>
					<div className={innerWrapperStyle}>
						<div className={detailSideBarLayout.wrapper}>
							<div className={detailSideBarLayout.leftSide}>
								<div className={contentSection('#fff')}>
									<header>
										<h1 className={titleStyle}>{pageSettings.heading}</h1>
									</header>
									<div
										className={textStyle}
										dangerouslySetInnerHTML={{ __html: pageSettings.body }}
									/>

									<div className={innerWrapperStyle}>
										<section className={cardsSectionStyle}>
											{pageSettings.tiles.map((tile, i) => (
												<ColouredCard
													id={i}
													key={i}
													background={descriptionToHex(tile.colour)}
													href={tile.link_destination}
													title={tile.heading}
													body={tile.body}
													minHeight={200}
													arrow={true}
												/>
											))}
										</section>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				{/* <p>
					The colours in the data below can be extracted to hex with this:{' '}
					{descriptionToHex('pink')}
				</p>
				<pre>{JSON.stringify(pageSettings, null, 4)}</pre> */}
			</React.Fragment>
		);
	}
}

export const query = graphql`
	query MakeADonationPageQuery {
		page: allContentJson(
			filter: { id: { regex: "/content\\/get-involved-make-a-donation-page\\.json/" } }
		) {
			edges {
				node {
					heading
					body
					tiles {
						heading
						body
						link_destination
						colour
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/pages/get-involved/make-a-donation/index.js